export const IS_LOCAL = false;
export const IS_PRODUCTION = true;

export const PRODUCTION_FRONTEND_URL  = IS_PRODUCTION ? "https://demo.thefoodeshow.com/" : "https://dev/";
export const PRODUCTION_BACKEND_URL   = IS_PRODUCTION ? "https://demo-api.thefoodeshowapi.com/" : "https://api.dev/";

export const DEVELOPMENT_FRONTEND_URL = "http://localhost:8080/";
export const DEVELOPMENT_BACKEND_URL  = "http://localhost:8000/";
export const PREFIX                   = "eshow_";
export const DEFAULT_LANGUAGE         = "en";
export const APP_NAME                 = "Top Eshows";

export const FRONTEND_URL = IS_LOCAL ? DEVELOPMENT_FRONTEND_URL : PRODUCTION_FRONTEND_URL;
export const BACKEND_URL  = IS_LOCAL ? DEVELOPMENT_BACKEND_URL  : PRODUCTION_BACKEND_URL;

// Pusher Configuration
export const PUSHER_KEY = 'fd77760e268fd35818c6';
export const PUSHER_CLUSTER = 'eu';
export const PUSHER_ENCRYPTED = true;

// Whereby Configuration
export const WHEREBY_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJodHRwczovL2FjY291bnRzLmFwcGVhci5pbiIsImF1ZCI6Imh0dHBzOi8vYXBpLmFwcGVhci5pbi92MSIsImV4cCI6OTAwNzE5OTI1NDc0MDk5MSwiaWF0IjoxNzU2MjE0NDQ1LCJvcmdhbml6YXRpb25JZCI6MzIzMzg3LCJqdGkiOiJmM2ZhNWNjYS04YzlhLTQ4ODAtYmM2NC04ZDJjNGZjNTg3ZmIifQ.IC7f0HW3HVDTpecrk2mko3xQyl3K76sd78MAYQRk6HU'; // Replace with your actual API key
export const WHEREBY_SUBDOMAIN = 'the-foode-show-demo'; // Replace with your subdomain if using Whereby Embedded
export const WHEREBY_ENVIRONMENT = IS_LOCAL ? 'staging' : 'production';
